import { useMemo, useState } from "react";
import { useToastContext } from '../../../../../../common/components/ui/toast/toast.context';
import ButtonWithLoader from "../../../../../../common/components/ui/loading/ButtonLoading";
import { bindVheicleVelotrack } from "../../../../services/integration.api";
import { FaCheckCircle } from "react-icons/fa";
import "./VelotrackActivate.scss"

type FormPropsBindVehcileVelotrack = {
  onSave: (vehicleId: string) => void
  renterId: string
  disabled?: boolean
};

export default function VelotrackActivate(props: FormPropsBindVehcileVelotrack) {
  const { notifySuccess, notifyError } = useToastContext()
  const [bindVelotrackInProgress, setBindVelotrackInProgress] = useState(false)
  const [buttonColor, setButtonColor] = useState<string>('text-redPrimary');

  async function handleApproveVelotrack() {
    try {
      setBindVelotrackInProgress(true)
      const approveRenterProps = {
        renterId: props.renterId,

      };
      const result = await bindVheicleVelotrack(approveRenterProps)

      if (!result.ok) {
        notifyError("Erro ao criar vinculo na Velotrack")
        return
      }

      notifySuccess("Vinculo criado na Velotrack com sucesso!")
      setButtonColor('success')

    } catch (err) {
      console.log(err)
    } finally {
      setBindVelotrackInProgress(false)
    }
  }
  const badgeColor = useMemo(() =>
    (buttonColor == "success")
      ? 'text-greenPrimary'
      : 'text-gray'
    , [buttonColor])
  return (
    <div className="p-0 grid-class">
      <div>
        <h2 className="font-semibold ">Clique aqui para vincular os dados no Velotrack:</h2>
      </div>
      <div className="grid-div2">
        <ButtonWithLoader
          type="button"
          disabled={props.disabled || bindVelotrackInProgress}
          isLoading={bindVelotrackInProgress} onClick={handleApproveVelotrack}>
          Velotrack
        </ButtonWithLoader>
        <FaCheckCircle size={24} className={`${badgeColor}`} />
      </div>
    </div>
  )
}
